import React, { Component } from 'react'

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import Login from './pages/Login'
import Logout from './pages/Logout'
import LogoutAll from './pages/LogoutAll'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import 'antd/dist/antd.less';
import { AuthProvider, RequireAuth } from './components/Auth'
const store = configureStore();


// https://kamranicus.com/posts/2018-07-26-react-router-custom-transition-ui
const getUserConfirmation = (message, callback) => {
	console.log(message);
	callback(false);
}

function App(props) {
	React.useEffect(() => {
		window.addEventListener('popstate', function (e) {
			if (e.state && e.state.cb && window.historyCallbackFunctions[e.state.cb]) {
				window.historyCallbackFunctions[e.state.cb].apply(this, arguments);
			}
		}, false);
	}, []);

	return (
		<AuthProvider>
			<Provider store={store}>
				<BrowserRouter getUserConfirmation={getUserConfirmation}>
					<Routes>
						<Route path="/" element={<Navigate replace to="/app" />} />
						<Route path="/app/signup" element={<Signup />} exact />
						<Route path="/app/login" element={<Login />} exact />
						<Route path="/app/forgot-password" element={<ForgotPassword />} exact />
						<Route path="/app/reset-password" element={<ResetPassword />} exact />
						<Route path="/app/logout" element={
							<RequireAuth>
								<Logout />
							</RequireAuth>
						} exact />
						<Route path="/app/logoutall" element={
							<RequireAuth>
								<LogoutAll />
							</RequireAuth>
						} exact />
						<Route path="/app*" element={
							<RequireAuth>
								<Home />
							</RequireAuth>
						} />
					</Routes>
				</BrowserRouter>
			</Provider>
		</AuthProvider>
	)
}

export default App;